<template>
  <div v-if="showConfig" class="nav" mg-stat-mod="nav">
    <div v-for="(item,index) in tabData" :key="index">
      <section :mg-stat-custom="'label=icon&cont='+item.module_name+'&direct=web&addr='+item.path" mg-stat-click
               @click="routeChange(item.path)">
        <div v-if="item.type == 0" class="nav_item">
          <i :class="getIconClass(item.path)" :style="getConfigIconStyle(item)"></i>
          <p>{{ item.module_name }}</p>
        </div>
        <div v-else :style="getConfigIconStyle(item)" class="nav_block">
        </div>
      </section>
    </div>
  </div>
  <!-- 如果没有配置则取默认的tab -->
  <div v-else class="nav" mg-stat-mod="nav">
    <section class="nav_item" mg-stat-click mg-stat-custom="label=icon&cont=首页&direct=web&addr=home"
             @click="routeChange('home')">
      <i :class="getIconClass('home')"></i>
      <p>首页</p>
    </section>
    <section class="nav_item" mg-stat-click mg-stat-custom="label=icon&cont=分类&direct=web&addr=class"
             @click="routeChange('class')">
      <i :class="getIconClass('class')"></i>
      <p>分类</p>
    </section>
    <section class="nav_item" mg-stat-click mg-stat-custom="label=icon&cont=购物车&direct=web&addr=cart"
             @click="routeChange('cart')">
      <span>{{ cartNum }}</span>
      <i :class="getIconClass('cart')"></i>
      <p>购物车</p>
    </section>
    <section class="nav_item" mg-stat-click mg-stat-custom="label=icon&cont=我&direct=web&addr=my"
             @click="routeChange('my')">
      <i :class="getIconClass('my')"></i>
      <p>我</p>
    </section>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import _ from 'lodash';

export default {
  data() {
    const { name } = this.$route;
    return {
      name,
    };
  },
  computed: {
    ...mapState('goods', ['cartData']),
    ...mapState('homePage', ['tabData', 'homePageData']),
    cartNum() {
      return this.cartData.length;
    },
    showConfig() {
      return !_.isEmpty(this.tabData);
    },
  },
  watch: {
    homePageData: {
      handler() {
        this.fetchTabtData(this.name);
      },
    },
  },
  created() {
    this.fetchCartData();
    this.fetchTabtData(this.name);
  },
  methods: {
    ...mapActions('goods', ['fetchCartData']),
    ...mapActions('homePage', ['fetchTabtData']),
    getIconClass(name) {
      return ['icon', this.name === name ? `nav_${name}_act active` : `nav_${name}`];
    },
    getConfigIconStyle(item) {
      return { backgroundImage: `url(${this.name === item.path ? item.title_img : item.bottom_img})` };
    },
    routeChange(name) {
      this.$router.push(`/${name}`);
    },
  },
};

</script>
<style lang="scss" scoped>
.nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  @media screen and (min-width: 1025px) {
    max-width: 500px; /*no*/
    margin: 0 auto;
  }

  &_item {
    text-align: center;
    height: 100px;
    line-height: 100px;
    font-size: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;

    p {
      line-height: 1;
      margin-top: 8px;
      color: #808080;
    }

    span {
      position: absolute;
      right: -10px;
      top: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 18px;
      color: #fff;
      background: #FF8315;
      border-radius: 50%;
      width: 36px;
      height: 36px;
    }
  }

  &_block {
    height: 100px;
    line-height: 100px;
    background-size: contain;
    background-repeat: no-repeat;
    width: 187.5px;
    background-position: center;
  }

  .active + p {
    color: #fd6901;
  }
}
</style>

